import requestAPI from "./request";
import PATH_CONFIG from "./path-config";

export default class ApiProductService {

  static localStore;

  static getApigeeServices() {

    if (ApiProductService.localStore) return ApiProductService.localStore;
    const options = {
      method: "GET",
    };

    return requestAPI(PATH_CONFIG.API_PRODUCTS, options)
        .then(response => {
          this.localStore = response;
          return response;
        });
  }
}



// WEBPACK FOOTER //
// ./src/services/api-products-service.js